import { useEffect, useState } from "react";

import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import AfterWorkPhoto from "../../../../../../Components/ViewURL/AfterWorkPhoto";
import ViewURL from "../../../../../../Components/ViewURL/ViewURL";
import { Get_WEB_GD_OfficerWisePendingWorkStatusDetails_SelectAPI, WorkAssignedTableDataAPI } from "../../../../../../Redux/GardenDashboardSlice/WorkAssignedSlice";
import { useAuthState } from "../../../../../../Helper/Context";
import { Pegination } from "../../../../../../Components/Pegination/Pegination";
import { Loading } from "../../../../../../Helper/Loading";

export const PopUpWorkAssign = (props) => {
    const { handleOpenModal, ApiFlag, FinancialYear, Month, GridFlag, handleCloseModal, WorkAssignByM_UserID, officerData, M_AssetTypeID, heading, fromDate, toDate } = props;
    const { m_WardID } = officerData;
    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user;
    const dispatch = useDispatch();

    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)

    const [ImageHeading, setImageHeading] = useState('')
    const [showWorkImagePopup, setshowWorkImagePopup] = useState(false)
    const [workPhotoData, setworkPhotoData] = useState('')
    const [AfterWorkPhotoData, setAfterWorkPhotoData] = useState('')
    const [workGridData, setworkGridData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    // const [fromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'))
    // const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'))
    // const [fromDate, setFromDate] = useState('')
    // const [toDate, setToDate] = useState('')

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const handleShowAfterImage = (img) => {
        setshowWorkImagePopup(true)
        setworkGridData(img)
        setworkPhotoData(img?.workPhoto)
        setAfterWorkPhotoData(img?.afterWorkPhoto)
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        // setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        // setToDate(moment().format('YYYY-MM-DD'))

    }

    useEffect(() => {
        const data = {
            M_FinancialYearID: moment().format('YYYY'),
            M_MonthID: moment().format('MM'),
            FromDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : "",
            ToDate: toDate ? moment(toDate).format('YYYY-MM-DD') : "",
            M_WorkTypeID: '0',
            M_AssetTypeID: M_AssetTypeID,
            M_WardID: m_WardID,
            M_ZoneID: '0',
            WorkAssignByM_UserID: WorkAssignByM_UserID,
            M_ContractorID: '0',
            M_UserID: UserID,
            ShowBy: ApiFlag,
            token: token,
            From: From,
            To: To,
            Flag: GridFlag,
        }
        // dispatch(WorkAssignedTableDataAPI({ data }))
        dispatch(Get_WEB_GD_OfficerWisePendingWorkStatusDetails_SelectAPI({ data }))
    }, [From, To, IsPost, IsClear, isSearch])

    const { tableData, isLoading } = useSelector(state => state.Get_WEB_GD_OfficerWisePendingWorkStatusDetails_SelectData)

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }


    return (
        <>
            <div
                className="modal fade show zIndex"
                style={{
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#00000090",
                }}
            >
                <div
                    className="modal-dialog modal-dialog-scrollable modal-xl"
                    role="document"
                >
                    <div
                        className="modal-content  p-3"
                        style={{ height: "75vh", width: "90vw" }}
                    >
                        <div className="modal-header py-2">
                            <h5 className="card-title heading_modal font">{heading}</h5>
                            <button type="button" className="btn-close mr-3 mt-1" data-dismiss="modal" aria-label="Close" data-backdrop='static'
                                style={{ color: 'white' }}
                                onClick={() => {
                                    handleCloseModal(false)
                                }} />



                        </div>
                        {isLoading && <Loading />}
                        <div className="modal-body w-100 mx-0 py-0 ">
                            <div className="row  pb-4 ">
                                <div className="col-12 mb-3">
                                    <table
                                        id="totalordergenerated"
                                        cellPadding="0"
                                        cellSpacing="0"
                                        border="0"
                                        className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="pt-3" style={{ background: '#048a8b' }}>Sr No.</th>
                                                <th style={{ width: "7em", background: '#048a8b' }}>Assign Date</th>
                                                <th style={{ background: '#048a8b' }}>Work Type</th>
                                                <th style={{ background: '#048a8b' }}>Asset Name</th>
                                                <th style={{ background: '#048a8b' }}>Ward Name</th>
                                                <th style={{ background: '#048a8b' }}>Sector Name</th>
                                                {/* <th style={{ background: '#048a8b' }}>Area</th> */}
                                                <th style={{ background: '#048a8b' }}>Work Name</th>
                                                <th style={{ background: '#048a8b' }}>Assign Work Photo</th>
                                                <th style={{ width: "6em", background: '#048a8b' }}>Work Date</th>
                                                <th style={{ background: '#048a8b' }}>After Work Photo</th>
                                                <th style={{ background: '#048a8b' }}>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                    <tr>
                                                        <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                        <td>{item.workAssignDate ? moment(item.workAssignDate).format("DD-MM-YYYY") : '-'}</td>
                                                        <td>{item.workTypeName ? item.workTypeName : '-'}</td>
                                                        <td>{item.assetName ? item.assetName : '-'}</td>
                                                        <td>{item.wardName ? item.wardName : '-'}</td>
                                                        <td>{item.sectorName ? item.sectorName : '-'}</td>
                                                        {/* <td>{item.areaName ? item.areaName : '-'}</td> */}
                                                        <td>{item.workname ? item.workname : '-'}</td>
                                                        <td style={{ textAlign: "center" }}>
                                                            {
                                                                (item.workPhoto == null) ?
                                                                    <span>-</span>
                                                                    :
                                                                    <>
                                                                        <i className="fa-solid fa-eye" title='View'
                                                                            style={{ cursor: 'pointer', alignItems: "center" }}
                                                                            onClick={() => (
                                                                                handleShowImage(item.workPhoto),
                                                                                setImageHeading("Checklist Photo")
                                                                            )}
                                                                        ></i>
                                                                    </>
                                                            }
                                                        </td>

                                                        <td>{item.workDate ? moment(item.workDate).format("DD-MM-YYYY") : '-'}</td>
                                                        <td style={{ textAlign: "center" }} >
                                                            {
                                                                (item.afterWorkPhoto == null) ?
                                                                    <span>-</span>
                                                                    :
                                                                    <>
                                                                        <i className="fa-solid fa-eye" title='View'
                                                                            style={{ cursor: 'pointer', alignItems: "center" }}
                                                                            onClick={() => (
                                                                                handleShowAfterImage(item)

                                                                            )}
                                                                        ></i>
                                                                    </>
                                                            }
                                                        </td>

                                                        <td>{item.statusName ? item.statusName : '-'}</td>

                                                    </tr>
                                                ) :
                                                    <td colSpan={15}>No data found</td>
                                            }
                                        </tbody>
                                    </table>
                                    {tableData && tableData.table && tableData.table.length > 0 &&
                                        <Pegination
                                            PerPageCount={PerPageCount}
                                            TotalCount={tableData.table[0].totalCount}
                                            setFrom={setFrom}
                                            setTo={setTo}
                                            setrowNo={setrowNo}
                                            CurrentPage={CurrentPage}
                                            setCurrentPage={setCurrentPage}
                                        />
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {
                showImagePopup ?
                    <ViewURL
                        Heading={ImageHeading}
                        setshowImagePopup={setshowImagePopup}
                        ImagePopUpData={ImagePopUpData}
                    />
                    : ''

            }
            {
                showWorkImagePopup ?
                    <AfterWorkPhoto
                        Heading={ImageHeading}
                        setshowWorkImagePopup={setshowWorkImagePopup}
                        workPhotoData={workPhotoData}
                        AfterWorkPhotoData={AfterWorkPhotoData}
                        workGridData={workGridData}
                        Flag="WorkNameHeading"
                        LatLongFlag="LatLongFlag"
                    />
                    : ''
            }
        </>
    );
};
